<template>
  <div>
    <div class="container bg-light my-3 py-3 px-4">

      <div class="row">
        <div class="col-12">
          <h2 class="ms-4 text-start">Create user</h2>
          <hr>
        </div>
      </div>

      <div class="row mt-3"> 
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            label="Enter User First Name"
            placeholder="First Name"
            @input="(e) => this.user.name = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            label="Enter User Lastname"
            placeholder="Lastname"
            @input="(e) => this.user.lastname = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="password"
            label="Enter user password"
            placeholder="Password"
            iconRight
            @input="(e) => this.user.password = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="email"
            label="Enter user email"
            placeholder="Email"
            @input="(e) => this.user.email = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3"> 
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            label="Enter Username"
            placeholder="Username"
            @input="(e) => this.user.username = e.target.value"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <ca-smtt-multiselect
            ref="sites-multiselect"
            :initialValue="initialSites"
            placeholderToTag="Add"
            placeholder="Smartmatic apps"
            name="name"
            label="Grant this user permision to smartmatic services"
            :optionsToSelect="sitesToAdd"
            @handleAddTagging="addTag"
          />
        </div>
      </div>

      <div class="row mt-3"
        v-for="site in selectedSites" :key="site.code"
      >
        <div class="col-12 col-lg-6">
          <ca-smtt-input
            type="text"
            :label="`Enter Username for ${site.name}`"
            :placeholder="`${site.name} Username for this user`"
            @change="handleUsernameInput($event, site.code)"
            @unMounted="handleUsernameDelete($event, site.code)"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-lg-6">
          <input 
            type="checkbox" 
            class="btn-check" 
            id="edit_user_admin_checkbox" 
            :value="user.is_admin"
            v-model="user.is_admin"
          >
          <label
            class="btn btn-outline-primary" 
            for="edit_user_admin_checkbox"
          >
            Admin
          </label>
        </div>
      </div>

      <div class="row my-4">
        <div class="col-6 col-lg-3">
          <button class="btn btn-outline-primary w-100" @click="goBack">
            Dismiss
          </button>
        </div>
        <div class="col-6 col-lg-3">
          <button 
            :disabled="disableCreateButton"
            class="btn btn-primary w-100" 
            @click="handleCreateUser"
          >
            Create
          </button>
        </div>
      </div>
    
    </div>

  </div>
</template>
<script>
import caSmttInput from '@/components/ca-smtt-input.vue'
import CaSmttMultiselect from '@/components/ca-smtt-multiselect.vue'
import { createUser } from '@/services/users/user.api.js'
import { getSites } from '@/services/sites/site.api.js'

export default {
  data() {
    return {
      user: {
        name: null,
        lastname: null,
        username: null,
        password: null,
        email: null,
        sites: [],
        is_admin: false,
      },
      initialSites: [],
      sitesToAdd: [],
      selectedSites: []
    }
  },
  async mounted() {
    await this.getSitesData()
    this.$watch(
      () => {
        return [this.$refs['sites-multiselect'].value]
      },
      ([selectedSites]) => {
        this.selectedSites = selectedSites
      }
    );
  },
  computed: {
    usernameSitesOK() {
      return (
        (this.selectedSites.length === this.user.sites.length) && this.user.sites.every(site => site.usernameSite)
      )
    },
    disableCreateButton() {
      return (
        !this.user.name
        || !this.user.lastname
        || !this.user.username
        || !this.user.password
        || !this.user.email
        || !this.usernameSitesOK
      )
    }
  },
  components: { caSmttInput, CaSmttMultiselect },
  methods: {
    handleUsernameInput(event, siteCode) {
      const siteFound = this.user.sites.find(site => site.siteId === siteCode)
      
      if (!siteFound) this.user.sites.push( { siteId: siteCode, usernameSite: event.target.value } )
      
      if (siteFound) {
        this.user.sites = this.user.sites.map(site => {
          if (site.siteId === siteFound.siteId) {
            site['usernameSite'] = event.target.value
          }
          return site
        })
      }
    },
    handleUsernameDelete(e, siteCode){
      this.user.sites = this.user.sites.filter(site => parseInt(site.siteId) !== siteCode)
    },
    async getSitesData() {
      try {
        const { data } = await getSites()
        this.sitesToAdd = data.sites.map(site => ({code: site.id, name: site.site}))
      } catch (error) {
        console.log(error)
      }
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.sitesToAdd.push(tag)
      this.initialSites.push(tag)
    },
    async handleCreateUser() {
      
      const user = {
        "name": this.user.name,
        "last_name": this.user.lastname,
        "email": this.user.email,
        "username": this.user.username,
        "password": this.user.password,
        "sites": this.user.sites.map(site => ({ siteId: parseInt(site.siteId), usernameSite: site.usernameSite })),
        "is_admin": this.user.is_admin,
      }

      try {
        await createUser(user)
        // console.log(user)
        this.$toast.open({
          message: 'User Successfully Created',
          type: 'success'
        })

        this.$router.back()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: error.message,
          type: 'error'
        })
      }

    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>